export default "__VITE_ASSET__CSPPjmCH__"